import { useEffect, useState } from "react";
import { Edit } from "../../resources/assetsManager";
import { WHITE_COLOR } from "../../resources/colorsManager";

const ProfileContainer = ({ header = "", headerValue = "", width, data }) => {
  const [keys, setKeys] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    let temp = Object.keys(data);
    let temp1 = Object.values(data);
    setKeys(temp);
    setValues(temp1);
  }, [data]);
  return (
    /* changed the flex direction */
    <div
      style={{
        backgroundColor: WHITE_COLOR,
        width: width,
        borderRadius: "20px",
        color: "black",
        boxSizing: "border-box",
        display: "flex",
        marginTop: "5px",
        flexDirection: "column",
        justifyContent: "center",
        marginTop: 30,
      }}
    >
      <div
        style={{
          color: "black",
          display: "flex",
          padding: "15px 40px",
          fontSize: "16px",
          borderBottom: "1px solid grey",
          fontWeight: "500",
        }}
      >
        <p>
          {header} : {"  "}
        </p>

        <p>{headerValue}</p>
      </div>
      <div style={{ marginTop: "15px" }}>
        {keys &&
          keys.map((item, index) => {
            return (
              <div key={index}>
                {!Array.isArray(values[index]) && (
                  <div
                    style={{
                      borderBottom: "1px solid #F3F3F3",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingBottom: 15,
                      paddingTop: 15,
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "30%",
                        minWidth: "150px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{ color: "black", minWidth: 220, fontSize: 16 }}
                      >
                        {" "}
                        {Array.isArray(values[index]) ? "" : keys[index]}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        wordBreak: "break-all",
                        alignitems: "center",
                        width: "30%",
                        minWidth: "150px",
                        flexDirection: "column-reverse",
                      }}
                    >
                      <span
                        style={{
                          marginLeft: 0,
                          minWidth: 200,
                          color: "black",
                          fontSize: "16px",
                        }}
                      >
                        {Array.isArray(values[index]) ? "" : values[index]}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ProfileContainer;
